module.exports = __webpack_public_path__ + "img/64.4eda1010.png";